import(/* webpackMode: "eager" */ "/opt/www-roomvia-ai/app/designer/page.tsx");
